<template>
  <div id="app">
    <ProxyNotifications />
    <router-view/>
  </div>
</template>


<script>
import ProxyNotifications from '@/components/molecules/ProxyNotifications'

export default {
  components: {
    ProxyNotifications,
  },
}
</script>

<style lang="scss" src="@/globalStyle/reset.scss"></style>
